export default function Logo() {
  return (
    <img
      src="/ara-logo.png"
      alt="ARA Turnkey Projects"
      className="h-auto w-52 sm:w-64 lg:w-72"
      data-testid="brand-logo"
    />
  );
}

export function LogoDark({ className = "h-12 w-auto" }) {
  return (
    <img
      src="/ara-logo-dark.webp"
      alt="ARA Turnkey Projects"
      className={className}
      data-testid="brand-logo-dark"
    />
  );
}
